module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iru2H"))).then(() => parcelRequire('hEqeo'));